/* eslint-disable no-console,no-undef, camelcase */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import {
  getOrientation,
  resetOrientation,
  checkImage,
  getPermissionStatus,
  convertDateInTimezone,
  fetchApi,
  hexToRgba
} from "../../../utils/methods";
import { saveChallengeData, createActivityChallengeV2, getActivityChallengeById } from "../../../redux/actions/challengeActions";
import {
  getUserCompanyDetails,
  allowChallengeEventForSpouseDependent,
} from "../../../redux/actions/userProfileActions";
import { TimeZone, imageErrorMessage } from "../../../utils/constants";
import { withTranslation } from "react-i18next";
import { getAllCompanies } from "../../../redux/actions";
import {
  Layout,
  Container,
  InputContainer,
  StyledInputV2,
  StyledLabel,
  ButtonContainer,
  EditorContainer,
  Border,
} from "../../CreateEvent/style";
import { Main } from "../../AdminTeamCreation/styles";
import { closeIcon, UploadHDMIcon, RecognitionCloseIcon, AdminRightArrowIcon, RecognitionTickIcon, AdminLeftArrowIcon, LaunchIcon, CalendarBranding, ChallengeLinkRightShapeIcon } from '../../../utils/icons';
import {CustomInput, SurvivorAverage, SurvivorChallengeSection, TitleContainer} from '../ActivityChallengeCreation/styles';
import { Heading, Locationwrapper} from "../../CreateEvent/style";
import { getCompanyLocation, getCompanyDepartment } from "../../../redux/actions";
import { GetTeams, GetCompanyTeamUsers, GetCompanyInfo, CreateChallenge } from '../../../redux/constants/apiConstants';
import { http } from '../../../redux/http';
import { ImageUrl } from "../../../utils/constants";
import { DateCalendarWrapper } from '../../ChallengeDetailsV2/StartChallengePopUp/styles';
import Waiting from '../../Waiting';
import { challengeTierPoints } from "../../../../mockData";
import CommonImageUploader from "../../common/CommonImageUploader/CommonImageUploader";
import CommonDropdown from "../../common/CommonDropDown/CommonDropdown";
import { SearchFilter1 } from "../../PeopleHomeV2/styles";
import dayjs from "dayjs";
import { FormHeading, DateCard, AddLinkContainer } from "./style";
import { ManagerIconContainer } from "../../Manager/styles";
import StepsHeading from "../../RecogntionAdmin/corevalues/stepNames"; 
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import {CommonButtonPopup} from '../../ReportsV2/styles'
import {RadioButtonWrapper, RadioButton} from '../../RecogntionAdmin/styles'
import {CommonButtonBorder} from '../../common/commonStyles'
import DatePopupCalendar from '../../common/DateRangePicker/daCalendarPopup'
import LinkModal from "./LinkModal";
import ChallengeLinkBanner from "./LinkBanner";
// import parse from 'react-html-parser';

class LaunchActivityChallenge extends Component {
  constructor(props) {
    super();
    const { survivorChallengeData, isGroupChallenge, isSurvivorChallenge, createLibrary } = props;
    let ImageName = '';
    if (!_.isEmpty(survivorChallengeData) && (props.activityChallengeById || props.editLibrary)) {
      const Array = survivorChallengeData.image.split('/');
      ImageName = Array[Array.length - 1];
    }
    let updatedTiers = challengeTierPoints;
    this.state = {
      title: _.get(survivorChallengeData, 'title', ''),
      date: dayjs(_.get(survivorChallengeData, 'date', new Date())),
      endDate: null,
      launchEndDate:null,
      scheduleStartDate: dayjs(new Date()),
      scheduleEndDate: null,
      description: _.get(survivorChallengeData, 'body', ''),
      imageName: ImageName,
      time: _.get(survivorChallengeData, 'time', dayjs().format('hh:mm a')),
      endTime: _.get(survivorChallengeData, 'endTime', dayjs().format('hh:mm a')),
      showDateTimeInput: '',
      activityType: isGroupChallenge ? survivorChallengeData.event_type === 'Total Steps' ? 'Total Group Steps' : survivorChallengeData.event_type === 'Total Calories' ? 'Total Group Calories' : 'Total Group Distance' : _.get(survivorChallengeData, 'event_type', 'Total Distance'),
      challengePointValue: _.get(survivorChallengeData, 'challenge_point', '0'),
      challengeMode: createLibrary ? 'Solo' : _.get(survivorChallengeData, 'challenge_mode', ''),
      weeklyIncrement: _.get(survivorChallengeData, 'weekly_increment', 0),
      survivorAverage: _.get(survivorChallengeData, 'survivor_average', 0),
      amigosToInvite: [],
      openDateTimePicker: '',
      imgSrc: ImageUrl+"/"+_.get(survivorChallengeData, 'image', ''),
      editImage:_.get(survivorChallengeData, 'image', ''),
      companies: _.get(survivorChallengeData, 'companies', []),
      location: [],
      isSpouse: false,
      usersToInvite:0,
      isDependent: false,
      isEmployee: false,
      challengePoints: updatedTiers,
      activityChallengeType: createLibrary ? "Classic challenge" : survivorChallengeData.challenge_type === 'new_group' ? 'Group Challenge' : survivorChallengeData.challenge_type === 'group' ? 'Classic challenge' : 'Survivor challenge',
      survivorChallenge: isSurvivorChallenge,
      groupChallenge: isGroupChallenge,
      imageUpdated: 0,
      challengePointKey: _.get(survivorChallengeData, 'challenge_point', '0')+" "+"Points",
      emailOption: {
        "launch_challenge_email": 0,
        "challenge_reminder_email": 0,
        "challenge_complete_email": 0
      },
      companiesPermission: false,
      locationPermission: false,
      selectedOption: 1,
      surveyId: '',
      surveyType: '',
      dailyGoal: null,
      selectedDailyGoalOption: 1,
      is_team_challenge:0,
      teams:[],
      allTeams:[],
      selectedCompany:{
        "id": 1,
        "company_name": "Woliba",
        "show_biometric": 1,
        "spouse_or_dependent": 1,
        "company_start_date": 2016,
        "show_events": 1,
        "show_education": 1,
        "show_employee_directory": 1 },

      step: 1,
      activityArrow: false,
      challengeType: false,
      pointsArrow: false,
      buttonClickScrollTop: false,
      menuIsOpen: true,
      selectedCompanyCheckBox: 0,
      selectedCompanyValue:null,
      selectedCompanyName: null,
      city_location: [],
      scheduleChallenge: null,
      buttonStatus: false,
      launchEndDateActive: false,
      scheduleStartDateActive: false,
      scheduleEndDateActive: false,
      placeholder:null,
      startDatePlaceholder:null,
      showLoader: false,
      challengeLength: null,
      weekArrow: false,
      selectUser: 0,
      city_department: [],
      companyInfo:null,
      searchTerm:'',
      filteredCompanies:[],
      lastDayToJoin: null,
      lastDayCustom: null,
      showDatePopupModal: false,
      datePopup:"date",
      charCount:0,
      hasLink:false,
      linkDetails:{    heading_text: "",
        button_text: "",
        url: "",
        banner_color: "#DA6C74"},
      showLinkModal:false
    }
  }

  componentDidMount() {
    this.getTeams(this.props.companyDetails.id);
    this.props.activityChallengeById || this.props.editLibrary ? this.fillProps() : null;
    const companiesPermission = getPermissionStatus("Show companies in challenge", this.props.userPermissions);
    const locationPermission = getPermissionStatus("Show locations in challenge", this.props.userPermissions);
    this.props.fetchCompanyForUser();
    this.props.allowChallengeEventForSpouseDependent();
    if(this.props.role!="ADMIN"&&!this.props.isAccountManager){
      this.setState({
        companies: this.props.userCompany && [this.props.userCompany.id]
      })}
    this.setState({
      companiesPermission: companiesPermission,
      locationPermission: locationPermission
    })
    document.addEventListener('mousedown', this.handleClick);

    if(this.props.role != "ADMIN"&& !this.props.isAccountManager){
      this.getTeams(this.props.companyDetails.id);
    }else{
      this.onCompanySelect('selectedCompany', this.state.selectedCompany, this.state.selectedCompany['key'])
    }
    this.getCompanyInfo(this.props.companyDetails.id)

    if (companiesPermission||this.props.isAccountManager) {
      if (!this.props.allCompanies) {
        this.props.fetchAllCompanies();
      }else{
        this.setState({filteredCompanies:this.props.allCompanies})
        
      }
    } 
  }

  componentDidUpdate(prevProps) {
    if (this.props.survivorChallengeData !== prevProps.survivorChallengeData || prevProps.surveyLibraries !== this.props.surveyLibraries) {
      this.props.activityChallengeById || this.props.editLibrary ? this.fillProps() : null;
    }
    if(prevProps.allCompanies != this.props.allCompanies){
      this.setState({filteredCompanies:this.props.allCompanies})
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClick);
  }

  onCompanySelect = async(name, value, key = '') => {
    const { challengePointKey } = this.state;
    const AuthToken = localStorage.getItem('AUTH_TOKEN');
    try {
      const res = await http.get(`${GetCompanyTeamUsers}/${value.id}`, {headers: {AUTHTOKEN: AuthToken}});
      if (res.message) {
        toast.error(res.message);
      }else{
        this.setState({
          allTeams:res,
          challengePointKey: key != '' ? key : challengePointKey,
        })
      }
    }catch(error){
      toast.error(error.message);
    }
  };

  fillProps = () => {
    const { survivorChallengeData, isGroupChallenge, isSurvivorChallenge, surveyLibraries } = this.props;
    const Array = survivorChallengeData.image.split('/');
    let ImageName = Array[Array.length - 1];
    let tierPointsIndex = this.state.challengePoints.findIndex((data) => data.value == _.get(survivorChallengeData, 'challenge_point', '0'));
    let surveyIndex = surveyLibraries && surveyLibraries.length > 0 ? surveyLibraries.findIndex((data) => data.id === survivorChallengeData.survey_id) : -1;
    const plainText = _.get(survivorChallengeData, 'body')
      ?.replace(/<[^>]*>/g, '')
      ?.replace(/&nbsp;/g, ' ')
      ?.trim();
    this.setState({
      title: _.get(survivorChallengeData, 'title'),
      date: dayjs(_.get(survivorChallengeData, 'date', new Date())),
      endDate: null,
      description: _.get(survivorChallengeData, 'body'),
      activityType: isGroupChallenge ? survivorChallengeData.event_type === 'Total Steps' ? 'Total Group Steps' : survivorChallengeData.event_type === 'Total Calories' ? 'Total Group Calories' : 'Total Group Distance' : _.get(survivorChallengeData, 'event_type', 'Total Distance'),
      challengePointValue: tierPointsIndex == -1 ? 0 : _.get(survivorChallengeData, 'challenge_point', '12'),
      challengeMode: _.get(survivorChallengeData, 'challenge_mode') || 'Solo',
      weeklyIncrement: _.get(survivorChallengeData, 'weekly_increment', 0) || 0,
      survivorAverage: _.get(survivorChallengeData, 'survivor_average', 0) || 0,
      imgSrc: ImageUrl+"/"+_.get(survivorChallengeData, 'image', ''),
      editImage:_.get(survivorChallengeData, 'image', ''),
      imageName: ImageName,
      survivorChallenge: isSurvivorChallenge,
      groupChallenge: isGroupChallenge,
      activityChallengeType: survivorChallengeData.challenge_type === 'new_group' ? 'Group Challenge' : survivorChallengeData.challenge_type === 'group' ? 'Classic challenge' : 'Survivor challenge',
      challengePointKey: this.state.challengePointValue+" "+"Points",
      surveyId: survivorChallengeData.survey_id,
      surveyType: surveyLibraries && surveyLibraries.length > 0 ? surveyLibraries[surveyIndex === -1 ? 0 : surveyIndex].survey_name : '',
      selectedOption: surveyIndex === -1 ? 1 : 0,
      dailyGoal: null,
      charCount: plainText?.length
    })
  }

  activityChallengeTypes = [
    {"key": "Classic challenge", "value": 'Classic challenge'},
    {"key": "Survivor challenge", "value": 'Survivor challenge'},
    {"key": "Group Challenge", "value": 'Group Challenge'}
  ]

  activityTypesItems= [
    {"key": "Total Steps", "value": 'Total Steps', 'label':"Steps"},
    {"key": "Total Distance", "value": 'Total Distance', 'label':"Distance"},
    {"key": "Total Calories", "value": 'Total Calories', 'label':"Calories"}
  ]

  groupActivityTypesItems= [
    {"key": "Total Group Steps", "value": 'Total Group Steps', 'label':"Total group steps"},
    {"key": "Total Group Distance", "value": 'Total Group Distance', 'label':"Total group distance"},
    {"key": "Total Group Calories", "value": 'Total Group Calories', 'label':"Total group Calories"}
  ]

  
  stepsHeadingEvent = [
    {
      name: 'About Challenge',
      showArrow: true,
      number: 1
    },
    {
      name: 'Customize Challenge',
      showArrow: true,
      number: 2
    },
    {
      name: 'Invite Users',
      showArrow: true,
      number: 3
    },
    {
      name: 'Launch Challenge',
      showArrow: false,
      number: 4
    }
  ]; 

  renderHeading = () => {
    const { survivorChallengeData } = this.props;
    const challengeType= survivorChallengeData.challenge_type=="survivor"?"Survivor Challenge":survivorChallengeData.challenge_type=="group"&&survivorChallengeData.is_team_challenge?this.props.t("Team Challenge"):survivorChallengeData.challenge_type=="new_group"?this.props.t("Charity Challenge"):this.props.t("Classic Challenge")
    return(
      <FormHeading color={"#184A61"}>
        <div className="close-icon" onClick={() => window.history.back() }>
          <ManagerIconContainer isWidth={"34px"}>{RecognitionCloseIcon('#F37A65')}</ManagerIconContainer>
        </div>
        {this.props.t("Launch ")} {this.props.t(challengeType)}
      </FormHeading>
    )};

  onChangeInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  onChange = (e) => {
    let file = e.target.files[0];
    if (checkImage(e.target.files)) {
      if ((file?.size / 1000000) <= 20) {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        const array = document.getElementById('create-challenge-file').value.split("\\");
        reader.onloadend = () => {
          this.setState({
            imgSrc: reader.result,
            imageName: array[array.length - 1],
            editImage: reader.result
          });
          getOrientation(file, (or) => {
            resetOrientation([reader.result], or, (baseImage) => {
              this.setState({
                imgSrc: baseImage,
                editImage: baseImage,
                imageUpdated: this.props.editLibrary ? 1 : 0
              });
            });
          });
        };
      } else {
        toast.error('Please select image file less than 20MB');
        document.getElementById('create-challenge-file').value = '';
      }
    } else {
      toast.error(imageErrorMessage);
      document.getElementById('create-challenge-file').value = '';
    }
  };

  onChangeDate = (value) => {
    let dateStr = value;
    let parts = dateStr.split('-');
    let formattedDate = parts[2] + '-' + parts[0] + '-' + parts[1];
    this.setState({
      endDate: dayjs(new Date(convertDateInTimezone(formattedDate))),
      placeholder: dayjs(new Date(convertDateInTimezone(formattedDate))),
      buttonStatus:false
    })
  }

  hideCalendar = () => {
    this.setState({
      launchEndDateActive: false,
    });
  };

  showCalendar = (date) => {
    if (date === "launchEndDateActive") {
      this.setState({
        launchEndDateActive: true,});
    } else if (date === "scheduleStartDateActive") {
      this.setState({
        scheduleStartDateActive: true,
        scheduleEndDateActive: false,
      });
    } else {
      this.setState({
        scheduleEndDateActive: true,
        scheduleStartDateActive: false,
      });
    }
  };


  onChangeScheduleDate = (value) => {
    let dateStr = value;
    let parts = dateStr.split('-');
    let formattedDate = parts[2] + '-' + parts[0] + '-' + parts[1];
    this.setState({
      date: dayjs(new Date(convertDateInTimezone(formattedDate))),
      endDate: dayjs(new Date(convertDateInTimezone(formattedDate))),
      startDatePlaceholder: dayjs(new Date(convertDateInTimezone(formattedDate))),
      buttonStatus:false,
      scheduleEndDate: dayjs(new Date(convertDateInTimezone(formattedDate)))
    })
  }

  onChangeDateV1 = (date, stateName) => {
    this.setState({
      [stateName]: dayjs(date),
    });
  };

  onChangeDateValue = (date, stateName) => {
    this.setState({
      [stateName]: dayjs(date),
      showDatePopupModal: false
    });
  };

  onImageChange = (imageSrc, imageName, editImage) => {
    this.setState({
      imgSrc: imageSrc,
      imageName: imageName,
      editImage: editImage,
    });
  };
  
  removePhoto = () => {
    this.setState({ imgSrc: null, editImage: null });
  };
  
  onChangeDescription = (e) => {
    const newContent = e.getData();
    const trimmedString = newContent.replace(/\s|&nbsp;/g, "");
    trimmedString.length === 0 ||
    trimmedString.length === 7 ||
    trimmedString == "<p></p><p></p>"
      ? this.setState({ description: "" })
      : this.setState({ description: newContent });
  };

  getTeams = async(companyId)=>{
    const AuthToken = localStorage.getItem('AUTH_TOKEN');
    try {
      const res = await http.get(`${GetTeams}/${companyId}`, {headers: {AUTHTOKEN: AuthToken}});
      if (res.message) {
        toast.error(res.message);
      }else{
        this.setState({
          allTeams:res
        })
      }
    }catch(error){
      toast.error(error.message);
    }
  }

  stepOneForm = () => {
    const {
      title,
      description,
      step,
      charCount
    } = this.state;
    const { t } = this.props;
    const maxLength = 3000;
    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container height="100%" stepBackground="#005C87" color="#005C87" paddingForm>
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="challenge" padding="20px 20px 265px 20px"/>
            </div>
            <div className="form">
              <div className="formBody">
                <InputContainer>
                  <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px">{this.props.t("Title of the challenge")}{<span className="imp">*</span>}</StyledLabel>
                  <StyledInputV2
                    placeholder={t("Enter challenge title")}
                    name="title"
                    value={title}
                    maxLength="60"
                    style={{ background: "white" }}
                    pColor={"#BDBDBD"}
                    color="#184A61"
                    onChange={this.onChangeInput}
                    isBorderColor={"1px solid #BDBDBD"}
                  />
                </InputContainer>
                <Border style={{ background: '#EFEFEF', margin: '8px 0 8px 0px' }} />
                <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px">{this.props.t("Challenge image")}{<span className="imp">*</span>}<span className="subtext">{("(use illustration)")}</span></StyledLabel>
                <CommonImageUploader
                  imgSrc={this.state.imgSrc}
                  t={t}
                  closeIcon={closeIcon}
                  UploadIcon={UploadHDMIcon}
                  onImageChange={this.onImageChange}
                  onRemoveImage={this.removePhoto}
                />
                <Border style={{ background: '#EFEFEF', margin: '8px 0px' }} />        
                <InputContainer>
                  <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px">{this.props.t("About the challenge")}{<span className="imp">*</span>}</StyledLabel>
                  <EditorContainer>
                    <CKEditor
                      editor={ClassicEditor}
                      data={description}
                      config={{
                        placeholder: 'Write description here...',
                        contentStyle: 'body { color: #184A61 !important; }'
                      }}
                      onReady={(editor) => {
                        this.editorInstance = editor;

                        const modelDocument = editor.model.document;

                        modelDocument.on('change:data', () => {
                          const data = editor.getData();
                          const plainText = data
                            .replace(/<[^>]*>/g, '')
                            .replace(/&nbsp;/g, ' ')
                            .trim();

                          const count = plainText.length;

                          if (count > maxLength) {
                            editor.execute('undo');
                            return;
                          }

                          this.setState({
                            description: data,
                            charCount: count,
                            disableButton: false,
                          });
                        });
                      }}
                    />

                  </EditorContainer>

                  <div className="char-count">{charCount}/3000 | C</div>
                </InputContainer>
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  };

  onSelect = (name, value, key) => {
    (name === "activityChallengeType") ?
      this.setState({
        [name]: value,
        survivorChallenge: value === "Survivor challenge",
        groupChallenge: value === "Group Challenge",
        activityType: value === "Group Challenge" ? "Total Group Distance" : "Total Distance",
        challengePointKey: this.state.challengePointKey,
        activityChallengeValue: key
      }) :
      this.setState({
        [name]: value,
      });
  };
  
  handleTypeofActivity = (name) => {
    this.setState({
      activityType: name.value,
    })
  };

  handleActivityType = (name) => {
    this.setState({
      activityType: name
    })
  };

  handleChallengeLink = (value) => {
    this.setState({
      hasLink: value
    })
  };

  onSelectWeeks = (value) => {
    this.setState({
      challengeLength: value  })
  };

  onSelectCompany = (name, value, key ) => {
    this.setState({
      [name]: value,
      selectedCompanyName: key,
      companies: [value],
      usersToInvite:0,
      isSpouse:false,
      isDependent:false,
      teams:[],
      city_location :[],
      city_department: [],
    });
    this.props.getCompanyLocation(value);
    this.props.getCompanyDepartment(value);
    this.getTeams(value);
    this.getCompanyInfo(value)
  };

  getCompanyInfo = async(companyId)=>{
    let apiUrl = GetCompanyInfo + "/" + companyId;
    try {
      const res = await fetchApi(apiUrl , "GET");
      if (res.status === "success") {
        this.setState({companyInfo: res?.data?.companyInfo?.[0]})

      } else {
        toast.error(res.error);
      }
    } catch (error) {
      window.console.error(error);
    }
  }

  isNumberKey = (evt) => {
    let charCode = (evt.which) ? evt.which : event.keyCode;
    if (charCode !== 46 && charCode > 31 && (charCode < 48 || charCode > 57)) evt.preventDefault();
  };

  toggleRadioGoalButton = (value) => {
    this.setState({   usersToInvite: parseInt(value,10) }, () => { });
    if(value===1){
      this.setState({
        teams:[]
      })
    }
    else{
      this.setState({
        city_location:[],
        city_department: []
      })
    }
  };



  onSelectPoints = (name) => {
    this.setState({
      challengePointValue: name.value,
      challengePointKey: name.key
    });
  };

  onAddUrlLink = ()=>{
    this.setState({showLinkModal:true})
  }

  onCloseUrlLink = ()=>{
    this.setState({showLinkModal:false})
  }

  onChangeLinkDetails = (e) => {
    const { name, value } = e.target;
  
    this.setState((prevState) => ({
      linkDetails: {
        ...prevState.linkDetails,
        [name]: value,
      },
    }));
  };

  stepTwoForm = () => {
    const {
      step,
      groupChallenge,
      activityType,
      survivorChallenge,
      survivorAverage,
      weeklyIncrement,
      challengePoints,
      pointsArrow,
      challengePointKey,
      challengePointValue,
      selectedDailyGoalOption,
      dailyGoal,
      hasLink,
      linkDetails,
      showLinkModal
    } = this.state;
    const { t, survivorChallengeData } = this.props;
    const activityTypes = groupChallenge ? this.groupActivityTypesItems : this.activityTypesItems;
    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container height="100%" stepBackground="#005C87" color="#005C87" paddingForm>
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="challenge" padding="20px 20px 265px 20px"/>
            </div>
            <div className="form">
              <div className="formBody">
                <TitleContainer widthValue="70%" height="auto" padding="0px">
                  <StyledLabel isFont={"14px"} color={"#184A61"} marginb="0px" margin="0px">{this.props.t("Type of activity")}{<span className="imp">*</span>}</StyledLabel>
                  <div className="radioButtonDiv">
                    <RadioButtonWrapper isMargin="12px" width gap>
                      {activityTypes?.map((data,index)=>(
                        <div className="RadioButtonContainer " onClick={() => this.handleActivityType(data?.key)} key={index}>
                          <RadioButton
                            type="radio"
                            checked={activityType === data.key}
                            handler={this.handleActivityType}
                            id={data.label+1}
                          />
                          <div className="label">{data?.label}</div>              
                        </div>))}
                    </RadioButtonWrapper>
                  </div>
                  <Border style={{background:'#EFEFEF',margin:'8px 0px 8px 0px'}}/>
                </TitleContainer>
                {(groupChallenge) &&
                  <SurvivorAverage  isMargin={"0px"} width="100%" marginb="0px" isHeight={"48px"}>
                    <StyledLabel isFont={"14px"} color={"#184A61"} marginb="12px" margin="0px">{activityType.includes('Distance')?"Total group distance goal": activityType.includes('Step')?"Total group step goal":"Total group calories goal"}{<span className="imp">*</span>}</StyledLabel>
                    <CustomInput
                      height={"48px"}
                      isRadius={"4px"}
                      isBorder={"1px solid #BDBDBD"}
                      isBgColor={"white"}
                      type='number'
                      name='survivorAverage'
                      onChange={this.onChangeInput}
                      value={activityType.includes('Distance') ? parseFloat(survivorAverage) : parseInt(survivorAverage,10)}
                      pattern='[0-9]*'
                      min="0"
                      onKeyPress={(e) => this.isNumberKey(e)}
                      placeholder={activityType.includes("Steps")?this.props.t("Enter E.g. 500 Steps"):activityType.includes("Calories")?this.props.t("Enter E.g. 30 Calories"):this.props.t("Enter E.g. 25 Miles")}
                    />
                    {<Border style={{background:'#EFEFEF',margin:'8px 0px 8px 0px'}}/> }
                  </SurvivorAverage>}
                <SurvivorChallengeSection>
                  {(survivorChallenge) && <SurvivorAverage display="block" isMargin={"0px"} marginb="0px" isHeight={"48px"} width="49.5%">
                    <StyledLabel isFont={"14px"} color={"#184A61"} marginb="12px" margin="0px">{groupChallenge ? t('Team Goal') : t('Week one Goal')}{<span className="imp">*</span>}</StyledLabel>
                    <CustomInput
                      width="100%"
                      height={"48px"}
                      isFont={"rubik"}
                      isRadius={"4px"}
                      isBorder={"1px solid #BDBDBD"}
                      isBgColor={"white"}
                      type='number'
                      name='survivorAverage'
                      onChange={this.onChangeInput}
                      value={activityType.includes('Distance') ? parseFloat(survivorAverage) : parseInt(survivorAverage,10)}
                      pattern='[0-9]*'
                      min="0"
                      onKeyPress={(e) => this.isNumberKey(e)}
                      placeholder={this.props.t("Enter aim/goal")}
                    />
                    <div className="char-count">
                      <div className="count">{activityType.includes("Steps")?"(Example: 5000 steps)":activityType.includes("Calories")?"(Example: 5000 calories)":"(Example: 50 miles)"}</div>
                      <div className="count"></div>
                    </div>
                  </SurvivorAverage>}
                  {survivorChallenge &&
              <SurvivorAverage display="block" width="49.5%" isMargin={"0px"} marginb="0px" isHeight={"48px"}>
                <StyledLabel isFont={"14px"} color={"#184A61"} marginb="12px" margin="0px">{t("Weekly increment")}{<span className="imp">*</span>}</StyledLabel>
                <CustomInput
                  width="100%"
                  height={"48px"}
                  isFont={"rubik"}
                  isRadius={"4px"}
                  isBorder={"1px solid #BDBDBD"}
                  isBgColor={"white"}
                  type='number'
                  name="weeklyIncrement"
                  value={parseFloat(weeklyIncrement)}
                  onChange={this.onChangeInput}
                  pattern='[0-9]*'
                  min="0"
                  onKeyPress={(e) => this.isNumberKey(e)}
                  placeholder={this.props.t("Enter increment")}
                />
              </SurvivorAverage>} 
                  {survivorChallenge &&<Border style={{background:'#EFEFEF',margin:'8px 0px 8px 0px'}}/> }
                </SurvivorChallengeSection>
                <TitleContainer widthValue="70%" height="auto" padding="0px" margin="0 0 8px 0">
                  <CommonDropdown
                    tileContainerStyle={{ width: "100%", padding: "0px 0px 0px 0px" }}
                    dropdownStyle={{ top: "90px" }}
                    labelText={t("Challenge point value")}
                    isRequired={true}
                    dropdownOpen={pointsArrow}
                    placeholder={t("Select point palue")}
                    title={challengePointKey=="0 Points"?"No Points":challengePointKey?t(challengePointKey) : t("Select point value")}
                    id="dropdown-recurring"
                    onClick={() => this.setState({ pointsArrow: !pointsArrow })}
                    data={challengePoints}
                    onSelect={this.onSelectPoints}
                    active={challengePointValue}
                    onSelectParameter={["value", "key"]}
                    itemValue={true}
                    valueIndex={1}
                    labelMargin={"0px"}
                    t={t}
                    fontSize={"14px"}
                    dropIcon={true}
                  />
                </TitleContainer>
                {survivorChallengeData.challenge_type === 'group'?<Border style={{background:'#EFEFEF',margin:'0px 0px 0px 0px', display:"flex"}}/>:null}
                {survivorChallengeData.challenge_type === 'group'?<StyledLabel isFont={"14px"} color={"#184A61"} margin="8px" marginb="0px">
                  {this.props.t("Would you like to set a daily goal")} ?{<span className="imp">*</span>}
                </StyledLabel>:null}
                {survivorChallengeData.challenge_type === 'group'?<div className="radioButtonDiv"><RadioButtonWrapper width gap>
                  <div className="RadioButtonContainer " onClick={() => this.toggleRadioButton("selectedDailyGoalOption",0)}>
                    <RadioButton
                      type="radio"
                      name="option"
                      checked={selectedDailyGoalOption === 0}
                      handler={this.toggleRadioButton}
                      id="1"
                      value={0}
                    />
                    <div className="label">Yes</div>
                  </div> 
                  <div className="RadioButtonContainer " onClick={() => this.toggleRadioButton("selectedDailyGoalOption",1)}>
                    <RadioButton
                      type="radio"
                      name="option"
                      checked={selectedDailyGoalOption === 1}
                      handler={this.toggleRadioButton}
                      id="2"
                      value={1}
                    />
                    <div className="label">No</div>
                  </div>
                </RadioButtonWrapper></div>:null}
                {selectedDailyGoalOption===0 && <Border style={{background:'#EFEFEF',margin:'8px 0px 0px 0px', display:"flex"}}/>}
                {selectedDailyGoalOption===0 &&
                <SurvivorAverage width="100%" isHeight={"48px"} isMargin="8px">
                  <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" marginb="12px">{t("Individual daily goal")}{<span className="imp">*</span>}</StyledLabel>
                  <CustomInput
                    isFont={"lato"}
                    isRadius={"4px"}
                    isBorder={"1px solid #BDBDBD"}
                    isBgColor={"white"}
                    type='number'
                    name='dailyGoal'
                    onChange={this.onChangeInput}
                    value={dailyGoal}
                    maxLength="10"
                    padding={"14px 16px"}
                    height="48px"
                    placeholder={activityType==="Total Distance"?"Enter distance goal":activityType==="Total Calories"?"Enter calorie goal":"Enter step goal"}
                  />
                </SurvivorAverage>}
                <Border style={{background:'#EFEFEF',margin:'8px 0px 8px 0px'}}/>
                <TitleContainer widthValue="70%" height="auto" padding="0px" margin="0px 0px 8px 0px">
                  <StyledLabel isFont={"14px"} color={"#184A61"} marginb="0px" margin="0px">{this.props.t("Do you want to add links in the challenge")}{<span className="imp">*</span>}</StyledLabel>
                  <div className="radioButtonDiv">
                    <RadioButtonWrapper isMargin="12px" width gap>
                      <div className="RadioButtonContainer " onClick={() => this.handleChallengeLink(true)}>
                        <RadioButton
                          type="radio"
                          checked={hasLink}
                          handler={this.handleActivityType}
                          id={'yes'}
                        />
                        <div className="label">{'Yes'}</div>              
                      </div>

                      <div className="RadioButtonContainer " onClick={() => this.handleChallengeLink(false)}>
                        <RadioButton
                          type="radio"
                          checked={!hasLink}
                          handler={this.handleActivityType}
                          id={'yes'}
                        />
                        <div className="label">{'No'}</div>              
                      </div>
                    </RadioButtonWrapper>
                  </div>
                  
                </TitleContainer>
                {hasLink ? linkDetails?.url ? <ChallengeLinkBanner
                  bgColor={hexToRgba(linkDetails?.banner_color  || '#75B084',"10%")}
                  shapeColor={linkDetails?.banner_color  || '#75B084'}
                  textColor={linkDetails?.banner_color  || '#75B084'}
                  color={linkDetails?.banner_color  || '#75B084'}
                  text={linkDetails?.heading_text}
                  rightButton={          <CommonButtonPopup
                    as="a"
                    href={linkDetails?.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    height="48px"
                    // width="100%"
                    margin="0 13.5% 0 0"
                    // onClick={isValid ? this.onSubmit : null}
                    style={{
                      backgroundColor: linkDetails?.banner_color  || '#75B084',
                      minWidth:"300px",
                      borderRadius:'6px'
                    }}
                  >
                    {linkDetails?.button_text}
                  </CommonButtonPopup>}
                  rightIcon={ChallengeLinkRightShapeIcon(linkDetails?.banner_color  || '#75B084')}
                  edit
                  onEdit={()=>this.setState({showLinkModal:true})}
                /> :<AddLinkContainer>
                  <div className="text">Add URL Link</div>
                  <CommonButtonPopup width="300px" onClick={this.onAddUrlLink}>Add URL</CommonButtonPopup>
                </AddLinkContainer> : null}
              </div>
            </div>
          </Container>
        </div>

        {showLinkModal && <LinkModal show={showLinkModal} title={'Add URL link'} onCancel={this.onCloseUrlLink} linkDetails={linkDetails} onChangeLinkDetails={this.onChangeLinkDetails}/>}
      </Layout>
    );
  };

  companyToggleButton = (e) => {
    this.setState({
      selectedCompanyCheckBox: e,
      companies: [],
      selectedCompanyValue: "",
    });
    if (e === 0) {
      this.setState({
        city_location: [],
      });
    }
  };

  toggleRadioButton = (name, value) => {
    this.setState({ [name]: value }, () => { });
    if(name=="selectedCompanyCheckBox"&&value===1){
      this.setState({
        companies:[],
        selectedCompanyName: null,
        selectedCompanyValue:null
      })
    }
    if(name=="selectedCompanyCheckBox"&&value===0){
      this.setState({
        usersToInvite:0,
        teams:[],
        city_location :[],
        city_department: [],
        isSpouse:false,
        isDependent:false,
        companies:[],
      })
    }
  };

  dateRadioButton = (name, value ) => {
    this.setState({ [name]: value });
    if(value===1){
      this.setState({
        date: dayjs(),
        endDate: null,
        placeholder: null,
        startDatePlaceholder: null,
        buttonStatus:false,
        challengeLength: null
      })
    }
    if(value===0){
      this.setState({
        date: dayjs(),
        placeholder: null,
        startDatePlaceholder: null,
        buttonStatus:false,
        challengeLength:null,
        endDate: null,
      })
    }
  };

  lastDayRadioButton = (name, value ) => {
    this.setState({
      [name]: value,
    });
    if(name==="lastDayToJoin"){
      this.setState({
        lastDayCustom: null,
      });
    }
    if(name==="lastDayCustom"){
      this.setState({
        lastDayToJoin: null,
      });
    }
  }

  onSelectSurveyType = (name, value, id) => {
    this.setState({
      [name]: value,
      surveyId: id
    });
  };

  selectAllCompanies = (e) => {
    e.preventDefault();
    let invitedCompanies = [];
    const { allCompanies } = this.props;
    if (this.state.companies.length === allCompanies.length) {
      invitedCompanies = [];
    } else {
      allCompanies && allCompanies.map((company) => {
        invitedCompanies.push(company.id);
      });
    }
    this.setState({
      companies: invitedCompanies
    })
  };


  

  inviteToggleButton = (e) => {
    this.setState({
      usersToInvite: e,
    });
    if (e === 0) {
      this.setState({
        // city_location: [],
      });
    }
  };
  

  onCheckboxChange = (element) => {
    const { companies } = this.state;
    if (companies.includes(element)) {
      let index = companies.findIndex((item) => item === element);
      if (index > -1) {
        companies.splice(index, 1);
      }
    } else {
      companies.push(element);
    }
    this.setState({
      companies: companies
    })
  };

  onSelectLocation = (name) => {
    this.setState({
      [name]: name.company_name,
      companies: [name.id],
      isEmployee:false,
      isDependent:false,
      isSpouse:false,
      selectedCompanyValue: name.company_name,
    });
    
    this.props.getCompanyLocation(name.id);
    this.props.getCompanyDepartment(name.id);
    this.getTeams(name.id);
    this.getCompanyInfo(name.id);
  };

  selectAllLocation = (e, locationDetails) => {
    e.preventDefault();
    const { city_location } = this.state;
    if (city_location.length == locationDetails.length) {
      this.setState({
        city_location: [],
      });
    } else {
      let arr = [];
      for (let i = 0; i < locationDetails.length; i++) {
        arr.push(locationDetails[i].id);
      }
      this.setState({
        city_location: arr,
      });
    }
  };

  selectAllDepartment = (e, departmentDetails) => {
    e.preventDefault();
    const { city_department } = this.state;
    if (city_department.length == departmentDetails.length) {
      this.setState({
        city_department: [],
      });
    } else {
      let arr = [];
      for (let i = 0; i < departmentDetails.length; i++) {
        arr.push(departmentDetails[i].id);
      }
      this.setState({
        city_department: arr,
      });
    }
  };

  onChangeLocation = (id) => {
    const { city_location } = this.state;
    if (city_location.includes(id)) {
      let index = city_location.findIndex((item) => item === id);
      if (index > -1) {
        city_location.splice(index, 1);
      }
    } else {
      city_location.push(id);
    }
    this.setState({
      city_location: city_location,
    });
  };

  onChangeDepartment = (id) => {
    const { city_department } = this.state;
    if (city_department.includes(id)) {
      let index = city_department.findIndex((item) => item === id);
      if (index > -1) {
        city_department.splice(index, 1);
      }
    } else {
      city_department.push(id);
    }
    this.setState({
      city_department: city_department,
    });
  };

  removeCommaFromFirstPlace = (str) => {
    if (str.charAt(0) === ",") {
      return str.substring(1);
    }
    return str;
  };

  handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    this.setState({ searchTerm: value });

    const filtered = this.props.allCompanies.filter((company) =>
      company.company_name.toLowerCase().includes(value)
    );

    this.setState({ filteredCompanies: filtered });
  };

  onChangeTeam = (id) => {
    const { teams } = this.state;
    if (teams.includes(id)) {
      let index = teams.findIndex((item) => item === id);
      if (index > -1) {
        teams.splice(index, 1);
      }
    } else {
      teams.push(id);
    }
    this.setState({
      teams: teams,
    });
  };


  selectAllTeam = (e, teamDetails)=>{
    e.preventDefault();
    const { teams } = this.state;
    if (teams.length == teamDetails.length) {
      this.setState({
        teams: [],
      });
    } else {
      let arr = [];
      for (let i = 0; i < teamDetails.length; i++) {
        arr.push(teamDetails[i].id);
      }
      this.setState({
        teams: arr,
      });
    }

  }

  onTeamsCheckboxChange = (element) => {
    const { teams } = this.state;
    if (teams.includes(element)) {
      let index = teams.findIndex((item) => item === element);
      if (index > -1) {
        teams.splice(index, 1);
      }
    } else {
      teams.push(element);
    }
    this.setState({
      teams: teams
    })
  };

  selectSpouseDependent = (stateName) => {
    this.setState((prev) => ({
      [stateName]: !prev[stateName],
    }));
  };


  stepThreeForm = () => {
    const {
      companies,
      city_location,
      companiesPermission,
      step,
      selectedCompanyValue,
      selectedCompanyCheckBox,
      isEmployee,
      isDependent,
      isSpouse,
      usersToInvite,
      allTeams,
      filteredCompanies,
      city_department,
      teams,
      companyInfo
    } = this.state;
    const { allCompanies, locationDetails, t, role, departmentDetails, isAccountManager } = this.props;
    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container color={"#005c87"}>
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="challenge" padding="20px 20px 265px 20px"/>
            </div>
            <div className="form">
              <div className="formBody">
                {(companiesPermission||isAccountManager) && (
                  <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px">
                    {this.props.t("Host your challenge for?")}{<span className="imp">*</span>}
                  </StyledLabel>
                )}
                {(companiesPermission||isAccountManager) && (
                  <div className="radioButtonDiv">
                    <RadioButtonWrapper width gap isMargin="0px">
                      <div className="RadioButtonContainer " onClick={() => this.companyToggleButton(0)}>
                        <RadioButton
                          id="global"
                          handler={this.companyToggleButton}
                          value={0}
                          checked={selectedCompanyCheckBox === 0}
                          label={t("Global")}
                          challengeCreate={true}
                          style={{color:"#092F41"}}
                          type="radio"
                          name="optionglobal"
                        />
                        <div className="label">Global</div>
                      </div>
                      <div className="RadioButtonContainer " onClick={() => this.companyToggleButton(1)}>
                        <RadioButton
                          id="For an Individual Company"
                          handler={this.companyToggleButton}
                          value={1}
                          checked={selectedCompanyCheckBox === 1}
                          label={t("For an Individual Company")}
                          challengeCreate={true}
                          style={{color:"#092F41"}}
                          type="radio"
                          name="For an Individual Company"
                        />
                        <div className="label">For an Individual Company</div>
                      </div>
                    </RadioButtonWrapper>
                  </div>
                )}
                {companiesPermission || isAccountManager? (<>
                  <Heading style={{display:'block'}}>
                    <div className="name" style={{color:"#184A61"}}>{this.props.t(`Select companies to invite`)} &nbsp; <span> {companies.length > 1 ? `(${companies.length} Companies Selected)`: companies.length === 1? "(1 Company Selected)": ""}</span></div>
                    <SearchFilter1 style={{width:"416px",maxWidth:"416px", background:'#fff'}}>
                      <StyledInputV2
                        type="text" placeholder={t("Search")}
                        value={this.state.searchTerm} 
                        onChange={this.handleSearch} 
                        style={{border:"none"}}
                        bordercolor="white"
                        isPadding={" 0px 20px 0px 12px"}
                        color="#184A61"
                        border="none"
                        pColor="#BDBDBD"
                      />
                      
                    </SearchFilter1>
                  </Heading>
    
                  <Locationwrapper background="white" isFlex={'1 1 50%'} isWidth="25%" marginTop="12px">
                    {selectedCompanyCheckBox === 0 ? <div className="checkBoxWidth">
                      <span style={{color:"#092F41",gap:"16px"}}>
                        <ManagerIconContainer selected={allCompanies && companies.length === allCompanies.length} isWidth="20px" isHeight="20px">
                          <div
                            className="archive-action"
                            onClick={(e) =>
                              this.selectAllCompanies(e, allCompanies)
                            }
                          >
                            {allCompanies && companies.length === allCompanies.length ? RecognitionTickIcon(): null}
                          </div>
                        </ManagerIconContainer>
                        {this.props.t("All Companies")}
                      </span>
                    </div>: null} 
                    {filteredCompanies && filteredCompanies.length > 0
                      ? filteredCompanies.map((company, index) => (
                        <div className="checkBoxWidth" key={index}>
                          <span style={{color:"#092F41",gap:"16px"}}>
                            <ManagerIconContainer selected={companies.includes(company.id)} isWidth="20px" isHeight="20px">
                              <div
                                className="archive-action"
                                onClick={() =>
                                  selectedCompanyCheckBox === 0 ? this.onCheckboxChange(company.id,company.company_name) : selectedCompanyCheckBox === 1 ? this.onSelectLocation(company) : null
                                }
                              >
                                {companies.includes(company.id) ? RecognitionTickIcon(): null}
                              </div>
                            </ManagerIconContainer>
                            {company.company_name}
                          </span>
                        </div>
                      )): null}
                  </Locationwrapper>
                </>) : null}
                {(role === "ADMIN"||isAccountManager) && (<Border style={{background:'#EFEFEF',margin:'20px 0px 0px 0px',display:"flex"}}/>)}

                {companies?.length > 0 ? (<><StyledLabel isFont={"14px"} color={"#184A61"} margin="8px" marginb="0px">
                  {this.props.t("Who would you like to invite?")}{<span className="imp">*</span>}
                </StyledLabel>

                {<div className="radioButtonDiv"><RadioButtonWrapper width gap>
                  <div className="RadioButtonContainer " onClick={() => this.inviteToggleButton(0)}>
                    <RadioButton
                      type="radio"
                      name="option1"
                      checked={usersToInvite === 0}
                      id="all-users"
                      value={0}
                      handler={this.inviteToggleButton}
                    />
                    <div className="label">All Users</div>
                  </div> 
                  {((role != "ADMIN"&&!isAccountManager) || selectedCompanyCheckBox === 1) && departmentDetails?.length > 0 &&<div className="RadioButtonContainer " onClick={() => this.inviteToggleButton(1)}>
                    <RadioButton
                      type="radio"
                      name="option2"
                      checked={usersToInvite === 1}
                      id="departments"
                      value={1}
                      handler={this.inviteToggleButton}
                    />
                    <div className="label">Departments</div>
                  </div>}
                  {((role != "ADMIN"&&!isAccountManager) || selectedCompanyCheckBox === 1) && locationDetails?.length > 0 &&<div className="RadioButtonContainer " onClick={() => this.inviteToggleButton(2)}>
                    <RadioButton
                      type="radio"
                      name="option3"
                      checked={usersToInvite === 2}
                      id="locations"
                      value={2}
                      handler={this.inviteToggleButton}
                    />
                    <div className="label">Locations</div>
                  </div>}
                  {((role != "ADMIN"&&!isAccountManager) || selectedCompanyCheckBox === 1) && allTeams.length > 0 &&<div className="RadioButtonContainer " onClick={() => this.inviteToggleButton(3)}>
                    <RadioButton
                      type="radio"
                      name="option4"
                      checked={usersToInvite === 3}
                      id="teams"
                      value={3}
                      handler={this.inviteToggleButton}
                    />
                    <div className="label">Teams</div>
                  </div>}
                </RadioButtonWrapper></div>}
                </>):null}
                {usersToInvite !=0 && (usersToInvite === 1&&departmentDetails?.length > 0||(usersToInvite === 2&&locationDetails?.length > 0)||(usersToInvite === 3&&allTeams.length > 0))&& <Border style={{background:'red',margin:'8px 0px 8px 0px'}}/>}
                {((role === "ADMIN"||isAccountManager) &&
                  locationDetails && 
                  locationDetails?.length > 0 &&
                  selectedCompanyCheckBox === 1 &&
                  selectedCompanyValue.length > 0 && usersToInvite === 2) ||
                (locationDetails &&
                  locationDetails?.length > 0 &&
                  (role != "ADMIN"&&!isAccountManager)  && usersToInvite === 2 ) ? (<Heading marginTop="0px">
                    <div className="name" style={{color:"#184A61"}}>
                      {this.props.t("Select locations")}
                      <span className="astric">*</span>
                    </div>
                  </Heading>
                  ) : null}
                {((role === "ADMIN"||isAccountManager) &&
                usersToInvite === 2 && locationDetails &&
                  locationDetails.length > 0 &&
                  selectedCompanyCheckBox === 1 &&
                  selectedCompanyValue.length > 0) ||
                (locationDetails &&
                  locationDetails.length > 0 &&
                  (role != "ADMIN"&&!isAccountManager)  && usersToInvite === 2 ) ? (
                    <Locationwrapper  background="white" style={{zIndex:"10",position:"relative"}} isWidth="25%" marginTop="12px">
                      <div className="checkBoxWidth" >
                        <span style={{color:"#092F41",gap:"16px"}}>
                          <ManagerIconContainer selected={city_location?.length === locationDetails?.length} isWidth="20px" isHeight="20px">
                            <div
                              className="archive-action"
                              onClick={(e) =>
                                this.selectAllLocation(e, locationDetails)
                              }
                            >
                              {city_location?.length === locationDetails?.length
                                ? RecognitionTickIcon()
                                : null}
                            </div>
                          </ManagerIconContainer>
                          {city_location.length === locationDetails.length
                            ? this.props.t("Deselect All")
                            : this.props.t("Select All")}
                        </span>
                      </div>
                      {locationDetails && locationDetails.length > 0
                        ? locationDetails.map((loc, index) => (
                          <div className="checkBoxWidth" key={index}>
                            <span style={{color:"#092F41",gap:"16px"}}>
                              <ManagerIconContainer selected={city_location.includes(loc.id)} isWidth="20px" isHeight="20px" >
                                <div
                                  className="archive-action"
                                  onClick={() => this.onChangeLocation(loc.id)}
                                >
                                  {city_location.includes(loc.id)
                                    ? RecognitionTickIcon()
                                    : null}
                                </div>
                              </ManagerIconContainer>
                              {this.removeCommaFromFirstPlace(loc.location)}
                            </span>
                          </div>
                        ))
                        : null}
                    </Locationwrapper>
                  ) : null}

                {/* Dpartment Listing */}

                {((role === "ADMIN"||isAccountManager) &&
                  departmentDetails && 
                  departmentDetails?.length > 0 &&
                  selectedCompanyCheckBox === 1 &&
                  selectedCompanyValue.length > 0 && usersToInvite === 1) ||
                (departmentDetails &&
                  departmentDetails?.length > 0 &&
                  (role != "ADMIN"&&!isAccountManager)  && usersToInvite === 1 ) ? (<Heading marginTop="0px">
                    <div className="name" style={{color:"#184A61"}}>
                      {this.props.t("Select departments")}
                      <span className="astric">*</span>
                    </div>
                  </Heading>
                  ) : null}
                {((role === "ADMIN"||isAccountManager) &&
                usersToInvite === 1 && departmentDetails &&
                  departmentDetails?.length > 0 &&
                  selectedCompanyCheckBox === 1 &&
                  selectedCompanyValue.length > 0) ||
                (departmentDetails &&
                  departmentDetails?.length > 0 &&
                  (role != "ADMIN"&&!isAccountManager)  && usersToInvite === 1 ) ? (
                    <Locationwrapper  background="white" style={{zIndex:"10",position:"relative"}} isWidth="25%" marginTop="12px">
                      <div className="checkBoxWidth" >
                        <span style={{color:"#092F41",gap:"16px"}}>
                          <ManagerIconContainer selected={city_department?.length === departmentDetails?.length} isWidth="20px" isHeight="20px">
                            <div
                              className="archive-action"
                              onClick={(e) =>
                                this.selectAllDepartment(e, departmentDetails)
                              }
                            >
                              {city_department?.length === departmentDetails?.length
                                ? RecognitionTickIcon()
                                : null}
                            </div>
                          </ManagerIconContainer>
                          {departmentDetails &&
                            city_department.length === departmentDetails?.length
                            ? this.props.t("Deselect All")
                            : this.props.t("Select All")}
                        </span>
                      </div>
                      {departmentDetails && departmentDetails?.length > 0
                        ? departmentDetails.map((dep, index) => (
                          <div className="checkBoxWidth" key={index}>
                            <span style={{color:"#092F41",gap:"16px"}}>
                              <ManagerIconContainer selected={city_department.includes(dep.id)} isWidth="20px" isHeight="20px">
                                <div
                                  className="archive-action"
                                  onClick={() => this.onChangeDepartment(dep.id)}
                                >
                                  {city_department.includes(dep.id)
                                    ? RecognitionTickIcon()
                                    : null}
                                </div>
                              </ManagerIconContainer>
                              {this.removeCommaFromFirstPlace(dep.department)}
                            </span>
                          </div>
                        ))
                        : null}
                    </Locationwrapper>
                  ) : null}

                {/* Teams Listing */}

                {((role === "ADMIN"||isAccountManager) &&
                  allTeams && 
                  allTeams.length > 0 &&
                  selectedCompanyCheckBox === 1 &&
                  selectedCompanyValue.length > 0 && usersToInvite === 3) ||
                (allTeams &&
                  allTeams.length > 0 &&
                  (role != "ADMIN"&&!isAccountManager)  && usersToInvite === 3 ) ? (<Heading marginTop="0px">
                    <div className="name" style={{color:"#184A61"}}>
                      {this.props.t("Select teams")}
                      <span className="astric">*</span>
                    </div>
                  </Heading>
                  ) : null}
                {((role === "ADMIN"||isAccountManager) &&
                usersToInvite === 3 && allTeams &&
                  allTeams.length > 0 &&
                  selectedCompanyCheckBox === 1 &&
                  selectedCompanyValue.length > 0) ||
                (allTeams &&
                  allTeams.length > 0 &&
                  (role != "ADMIN"&&!isAccountManager)  && usersToInvite === 3 ) ? (
                    <Locationwrapper  background="white" style={{zIndex:"10",position:"relative"}} isWidth="25%" marginTop="12px">
                      <div className="checkBoxWidth" >
                        <span style={{color:"#092F41", gap:"16px"}}>
                          <ManagerIconContainer selected={teams?.length === allTeams?.length} isWidth="20px" isHeight="20px">
                            <div
                              className="archive-action"
                              onClick={(e) =>
                                this.selectAllTeam(e, allTeams)
                              }
                            >
                              {teams?.length === allTeams?.length
                                ? RecognitionTickIcon()
                                : null}
                            </div>
                          </ManagerIconContainer>
                          {allTeams &&
                          teams.length === allTeams.length
                            ? this.props.t("Deselect All")
                            : this.props.t("Select All")}
                        </span>
                      </div>
                      {allTeams && allTeams.length > 0
                        ? allTeams.map((team, index) => (
                          <div className="checkBoxWidth" key={index + team}>
                            <span style={{color:"#092F41", gap:"16px"}} >
                              <ManagerIconContainer selected={teams.includes(team.id)} isWidth="20px" isHeight="20px">
                                <div
                                  className="archive-action"
                                  onClick={() => this.onChangeTeam(team.id)}
                                >
                                  {teams.includes(team.id)
                                    ? RecognitionTickIcon()
                                    : null}
                                </div>
                              </ManagerIconContainer>
                              {this.removeCommaFromFirstPlace(team.name)}
                            </span>
                          </div>
                        ))
                        : null}
                    </Locationwrapper>
                  ) : null}

                {(companyInfo?.show_spouse || companyInfo?.show_dependent ||  (locationDetails?.length === 0 && usersToInvite === 2)) && companies?.length > 0 && ((role != "ADMIN"&&!isAccountManager) || selectedCompanyCheckBox === 1) && (usersToInvite!==0 && usersToInvite!==3) ? ( <Border style={{background:'#EFEFEF',margin:'8px 0px 0px 0px',display:"flex"}}/>) : null}

                {/* Spouse Dependent */}

                {(companyInfo?.show_spouse || companyInfo?.show_dependent ||  (locationDetails?.length === 0 && usersToInvite === 2)) && companies?.length > 0 && ((role != "ADMIN"&&!isAccountManager) || selectedCompanyCheckBox === 1) && (usersToInvite!==0 && usersToInvite!==3) ? (
                  <Heading marginTop="8px">
                    <div className="name" style={{color:"#184A61"}}>{("Are you also interested in extending an invitation?")}</div>
                  </Heading>) : null}

                {companies?.length > 0 && ((role != "ADMIN"&&!isAccountManager) || selectedCompanyCheckBox === 1) && (usersToInvite!==0 && usersToInvite!==3) ? <Locationwrapper  background="white" isWidth="25%" marginTop="12px">
                  {companyInfo?.show_spouse ?<div className="checkBoxWidth">
                    <span style={{color:"#092F41",gap:"16px"}}>
                      <ManagerIconContainer selected={isSpouse} isWidth="20px" isHeight="20px">
                        <div
                          className="archive-action"
                          onClick={() => this.selectSpouseDependent("isSpouse")}
                        >
                          {isSpouse
                            ? RecognitionTickIcon()
                            : null}
                        </div>
                      </ManagerIconContainer>
                      {this.props.t("Spouse")}
                    </span>
                  </div>:null}
                  {companyInfo?.show_dependent ?<div className="checkBoxWidth">
                    <span style={{color:"#092F41",gap:"16px"}}>
                      <ManagerIconContainer selected={isDependent} isWidth="20px" isHeight="20px">
                        <div
                          className="archive-action"
                          onClick={() => this.selectSpouseDependent("isDependent")}
                        >
                          {isDependent
                            ? RecognitionTickIcon()
                            : null}
                        </div>
                      </ManagerIconContainer>
                      {this.props.t("Dependent")}
                    </span>
                  </div>:null}
                  {locationDetails?.length === 0 && usersToInvite === 2 &&  (
                    <div className="checkBoxWidth">
                      <span style={{color:"#092F41",gap:"16px"}}>
                        <ManagerIconContainer selected={isEmployee} isWidth="20px" isHeight="20px">
                          <div
                            className="archive-action"
                            onClick={() => this.selectSpouseDependent("isEmployee")}
                          >
                            {isEmployee
                              ? RecognitionTickIcon()
                              : null}
                          </div>
                        </ManagerIconContainer>
                        {this.props.t("Employee")}
                      </span>{" "}
                    </div>
                  )}
                </Locationwrapper>:null}
                {/* Spouse Dependent */}
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  };

  setDatePickerWrapper = (node) => {
    this.datePickerWrapper = node;
  };

  changeDate = (e, stateName) => {
    const { showDateTimeInput } = this.state;
    if (showDateTimeInput === 'date') {
      this.setState({
        date: dayjs(e._d).format('MM/DD/YYYY'),
        time: dayjs(e._d).format('hh:mm a'),
        endDate: dayjs(e._d).format('MM/DD/YYYY'),
        endTime: '11:59 pm',
        openDateTimePicker: '',
      });
    } else if (stateName.includes('ate')) {
      if(stateName === 'date'){
        this.setState({
          openDateTimePicker: '',
          [stateName]: dayjs(e._d).format('MM/DD/YYYY'),
          endDate:dayjs(e._d).format('MM/DD/YYYY'),
        });
      }else {
        this.setState({
          openDateTimePicker: '',
          [stateName]: dayjs(e._d).format('MM/DD/YYYY'),
        });

      }
    } else {
      this.setState({
        [stateName]: dayjs(e._d).format('hh:mm a'),
        openDateTimePicker: stateName
      });
    }
  };

  showDatePicker = (value) => {
    if (this.state.openDateTimePicker === value) {
      this.setState({
        openDateTimePicker: ''
      });
    } else {
      this.setState({
        openDateTimePicker: value
      });
    }
  };

  onChangeEmail = (key) => {
    const { emailOption } = this.state;
    emailOption[key] = emailOption[key] === 0 ? 1 : 0;
    this.setState({ emailOption: emailOption });
  }

  checkBase64(image) {
    if (image) {
      if (image.includes('base64')) {
        return true;
      }
      else {
        return false;
      }
    }
  }

  onSubmit = () => {
    // e.preventDefault();
    const { title, date, description, editImage, endDate, activityType, challengePointValue, challengeMode, weeklyIncrement,
      survivorAverage, companies, isSpouse, isDependent, challengeLength, survivorChallenge, groupChallenge, imageUpdated, emailOption, surveyId, selectedOption, dailyGoal, selectedDailyGoalOption, teams, imageName, city_location, city_department,  usersToInvite, lastDayToJoin,hasLink,linkDetails } = this.state;
   
    const {  createLibrary, activityChallengeById, editLibrary, saveChallengeData, isAccountManager } = this.props;
    let survivorEndDate = dayjs(dayjs(date).add((challengeLength * 7) - 1, 'days')).format('MM/DD/YYYY');
    let lastDaySelectValue= survivorChallenge?this.calculateDateDifference(date,survivorEndDate): (date&&endDate) && this.calculateDateDifference(date,endDate)
    const challengeType = survivorChallenge ? 'survivor' : groupChallenge ? 'new_group' : 'group';
    const challenge = {
      title,
      companies: this.props.role==="ADMIN"||isAccountManager?companies:this.props.userCompany && [this.props.userCompany.id],
      body: description,
      image: editImage,
      event_type: activityType === 'Total Group Steps' ? 'Total Steps' : activityType === 'Total Group Calories' ? 'Total Calories' : activityType === 'Total Group Distance'? 'Total Distance' : activityType,
      end_date: createLibrary || editLibrary ? null : (survivorChallenge) ? dayjs(survivorEndDate).format('YYYY-MM-DD') + ' ' + "23:59:59" : dayjs(endDate).format('YYYY-MM-DD') + ' ' + "23:59:59",
      start_date: createLibrary || editLibrary ? null : dayjs(date).format('YYYY-MM-DD') + ' ' + "00:00:00",
      survivor_average: survivorAverage,
      weekly_increment: survivorChallenge ? weeklyIncrement : null,
      challenge_point: challengePointValue,
      challenge_mode: survivorChallenge ? challengeMode : '',
      challenge_type: challengeType,
      isSurvivorChallenge: survivorChallenge,
      isGroupChallenge: groupChallenge,
      ...emailOption,
      survey_id: selectedOption === 1 ? null : surveyId,
      daily_goal: selectedDailyGoalOption === 1 ? null : dailyGoal,
      is_team_challenge:teams.length>0?1:0, 
      teams:teams,
      company_city_states :city_location,
      company_departments: city_department,
      challenge_for_spouse: isSpouse ? 1 : 0,
      challenge_for_dependent: isDependent ? 1 : 0,
      is_for_employee: 1,
      time_zone: TimeZone,
      days_until_last_date: lastDaySelectValue>3? lastDayToJoin:null,
      link_details : hasLink ? linkDetails : null
    };
    if(activityChallengeById){
      challenge.convert_image = !this.checkBase64(editImage)
    }
    if (editLibrary) {
      challenge.id = this.props.survivorChallengeData['id'];
      challenge.imageUpdated = imageUpdated
    }

    if(usersToInvite === 0){
      challenge.company_departments = [];
      challenge.company_city_states = [];
      challenge.teams = [];
    }else if(usersToInvite === 1){
      challenge.company_departments = city_department;
      challenge.company_city_states = [];
      challenge.teams = [];
    }else if(usersToInvite === 2){
      challenge.company_departments = [];
      challenge.company_city_states = city_location;
      challenge.teams = [];
    }else if(usersToInvite === 3){
      challenge.teams = teams;
      challenge.is_team_event=1;
      challenge.company_departments = [];
      challenge.company_city_states = [];
    }


    if(usersToInvite===0){
      challenge.challenge_for_spouse =1;
      challenge.challenge_for_dependent = 1;
    }
    saveChallengeData({ ...challenge, imageName });
    this.postChallengeData(challenge);
  };

  postChallengeData = async(payload)=>{

    this.setState({ buttonStatus: true });

    const{history} = this.props;
    try{
      const res = await fetchApi(CreateChallenge, "POST",payload);

      if(res.status === "failed"){
        toast.error(res?.data?.message);
        this.setState({ buttonStatus: false });
      }else{
        toast.success(res.data[0]);
        history.push({pathname:history.location.pathname.includes("/company/challenges/")?'/company/challenges/categories':'/challenges/categories'});
        this.setState({ buttonStatus: false });
      }

    }catch(error){
      toast.error(error);
      this.setState({ buttonStatus: false });

    }
  }

  scheduleDateHideCalendar = () =>{
    this.setState({
      scheduleStartDateActive: false
    })
  }

  scheduleEndDateHideCalendar = () =>{
    this.setState({
      scheduleEndDateActive: false
    })
  }

  onChanegeButton = (value) => {
    this.setState({
      launchEndDate: dayjs(new Date(value))
    })
  }

  onChanegeScheduleButton = (value) => {
    this.setState({
                            
      scheduleStartDate: dayjs(new Date(value))
    })
  }

  onChanegeScheduleEndButton = (value) => {
    this.setState({
      scheduleEndDate: dayjs(new Date(value))
    })
  }

  calculateDateDifference = ( date, endDate ) => {
    const start = new Date(date);
    const end = new Date(endDate);
  
    // Check if both dates are valid
    if (isNaN(start) || isNaN(end)) {
      throw new Error("Invalid date format");
    }
  
    // Reset time to midnight for accurate day diff
    start.setHours(0, 0, 0, 0);
    end.setHours(0, 0, 0, 0);
  
    const diffInMs = end - start;
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
  
    return diffInDays;
  }
  
  hideCalendarPopup= () =>{
    this.setState({
      showDatePopupModal: false,
      datePopup: ""
    })
  }

  hideShowCalendarPopup = (value) =>{
    this.setState({
      datePopup: value,
      showDatePopupModal: true
    })
  }

  // resetDatePopup = () =>{
  //   if(this.state.datePopup==="date"){
  //     this.setState({
  //       date: null
  //     })
  //   }else{
  //     this.setState({
  //       endDate: null
  //     })
  //   }
  // }

  stepFourForm = () => {
    const {
      step,
      scheduleChallenge,
      date,
      endDate,
      challengeLength,
      lastDayToJoin,
      lastDayCustom,
      survivorChallenge,
      showDatePopupModal,
      datePopup
    } = this.state;
    const {t, survivorChallengeData} = this.props;
    const survivorChallengeLengthDropdown = [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    let survivorEndDate = dayjs(dayjs(date).add((challengeLength * 7) - 1, 'days')).format('MM/DD/YYYY');
    let lastDaySelectValue= survivorChallenge?this.calculateDateDifference(date,survivorEndDate): (date&&endDate) && this.calculateDateDifference(date,endDate)
    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container height="100%" stepBackground="#005C87" color="#005C87" paddingForm>
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="challenge" padding="20px 20px 265px 20px"/>
            </div>
            <div className="form">
              <div className="formBody">
                <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" marginb="0px">
                  {t("When would you like to launch your challenge?")}{<span className="imp">*</span>}
                </StyledLabel>
                <div className="radioButtonDiv">
                  <RadioButtonWrapper width gap>
                    <div className="RadioButtonContainer " onClick={() => this.dateRadioButton("scheduleChallenge",0)}>
                      <RadioButton
                        id="Launch now"
                        handler={this.dateRadioButton}
                        value={0}
                        checked={scheduleChallenge === 0}
                        label={t("Launch now")}
                        style={{color:"#092F41"}}
                        type="radio"
                        name="option"
                      />
                      <div className="label">Launch now</div>
                    </div>
                    <div className="RadioButtonContainer " onClick={scheduleChallenge===1?null: () => this.dateRadioButton("scheduleChallenge",1)}>
                      <RadioButton
                        id="Schedule  for later"
                        handler={ scheduleChallenge===1?null:this.dateRadioButton}
                        value={1}
                        checked={scheduleChallenge === 1}
                        label={t("Schedule  for later")}
                        style={{color:"#092F41"}}
                        type="radio"
                        name="option"
                      />
                      <div className="label">Schedule  for later</div>
                    </div>
                  </RadioButtonWrapper>
                </div>
                {scheduleChallenge!==null?<Border style={{ background: '#EFEFEF', margin: '8px 0 8px 0px' }} />:null}
                {scheduleChallenge === 0 ?
                  <div className="dateCard" style={{marginTop:"0px",gap:"8px"}}>
                    <DateCalendarWrapper>
                      <div className="date-title">Start Date</div>
                      <DateCard color background disabled>
                        {date? dayjs(date).format('MM/DD/YYYY'): "Select Date"}
                        {CalendarBranding('#BDBDBD')}
                      </DateCard>
                    </DateCalendarWrapper> 
                    {survivorChallengeData.challenge_type=="survivor"?
                      <TitleContainer  height="auto" padding="0">
                        <p className="date-title">Weeks to end</p>
                        <CommonDropdown
                          tileContainerStyle={{ width: "100%", padding: "0px 0px 0px 0px" }}
                          dropdownStyle={{ top: "90px" }}
                          isRequired={true}
                          height={"50px"}
                          dropdownOpen={this.state.weekArrow}
                          placeholder={t("Select weeks to end")}
                          title={challengeLength && `${challengeLength} ${t("Weeks")}`}
                          id="dropdown-recurring"
                          onClick={() => this.setState({ weekArrow: !this.state.weekArrow })}
                          data={survivorChallengeLengthDropdown}
                          onSelect={this.onSelectWeeks}
                          active={challengeLength}
                          onSelectParameter={["value"]}
                          itemValue={false}
                          valueString={"Weeks"}
                          t={t}
                          isManagerMargin={"0px"}
                          labelMargin={"0px"}
                          fontSize={"14px"}
                          valueIndex={1}
                          dropIcon={true}
                          top={"7px"}
                        />
                      </TitleContainer>:
                      <DateCalendarWrapper>
                        <div className="date-title">End Date</div>
                        <DateCard color={!endDate} onClick={()=>this.hideShowCalendarPopup("endDate")}>
                          {endDate? dayjs(endDate).format('MM/DD/YYYY'): "Select Date"}
                          {CalendarBranding()}
                        </DateCard>
                      </DateCalendarWrapper>
                    }
                  </div>:scheduleChallenge === 1&&
                  <div className="dateCard" style={{marginTop:"0px",gap:"8px"}}>
                    <DateCalendarWrapper>
                      <div className="date-title">Start Date</div>
                      <DateCard color={!date} onClick={()=>this.hideShowCalendarPopup("date")}>
                        {date? dayjs(date).format('MM/DD/YYYY'): "Select Date"}
                        {CalendarBranding()}
                      </DateCard>
                    </DateCalendarWrapper> 
                    {survivorChallengeData.challenge_type=="survivor"?
                      <TitleContainer  height="auto" padding="0">
                        <p className="date-title">Weeks to end</p>
                        <CommonDropdown
                          tileContainerStyle={{ width: "100%", padding: "0px 0px 0px 0px" }}
                          dropdownStyle={{ top: "90px" }}
                          isRequired={true}
                          dropdownOpen={this.state.weekArrow}
                          placeholder={t("Select weeks to end")}
                          title={challengeLength && `${challengeLength} ${t("Weeks")}`}
                          id="dropdown-recurring"
                          onClick={() => this.setState({ weekArrow: !this.state.weekArrow })}
                          data={survivorChallengeLengthDropdown}
                          onSelect={this.onSelectWeeks}
                          active={challengeLength}
                          onSelectParameter={["value"]}
                          itemValue={false}
                          t={t}
                          isManagerMargin={"0px"}
                          labelMargin={"0px"}
                          fontSize={"14px"}
                          valueIndex={1}
                          dropIcon={true}
                          top={"7px"}
                          height={"50px"}
                          valueString={"Weeks"}
                        />
                      </TitleContainer>:
                      <DateCalendarWrapper>
                        <div className="date-title">End Date</div>
                        <DateCard color={!endDate} onClick={()=>this.hideShowCalendarPopup("endDate")}>
                          {endDate? dayjs(endDate).format('MM/DD/YYYY'): "Select Date"}
                          {CalendarBranding()}
                        </DateCard>
                      </DateCalendarWrapper>}
                  </div>}      
                {lastDaySelectValue>3?<>
                  {<Border style={{ background: '#EFEFEF', margin: '8px 0 8px 0px' }} />}
                  <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" marginb="0px">
                    {this.props.t("Last day to join after the challenge is launched")}{<span className="imp">*</span>}
                  </StyledLabel>
                  <div className="radioButtonDiv">
                    <RadioButtonWrapper width gap>
                      {<div className="RadioButtonContainer " onClick={() => this.lastDayRadioButton("lastDayToJoin",3)}>
                        <RadioButton
                          id="lastDayCustom3"
                          handler={this.lastDayRadioButton}
                          value={3}
                          checked={lastDayToJoin === 3}
                          style={{color:"#092F41"}}
                          type="radio"
                          name="option1"
                        />
                        <div className="label">{this.props.t("3 days")}</div>
                      </div>}
                      {lastDaySelectValue>7?<div className="RadioButtonContainer " onClick={lastDayToJoin===7?null: () => this.lastDayRadioButton("lastDayToJoin",7)}>
                        <RadioButton
                          id="lastDayCustom7"
                          handler={this.lastDayRadioButton}
                          value={7}
                          checked={lastDayToJoin === 7}
                          style={{color:"#092F41"}}
                          type="radio"
                          name="option2"
                        />
                        <div className="label">{this.props.t("7 days")}</div>
                      </div>:null}
                      {lastDaySelectValue>14?<div className="RadioButtonContainer " onClick={lastDayToJoin===14?null: () => this.lastDayRadioButton("lastDayToJoin",14)}>
                        <RadioButton
                          id="lastDayCustom14"
                          handler={this.lastDayRadioButton}
                          value={14}
                          checked={lastDayToJoin === 14}
                          style={{color:"#092F41"}}
                          type="radio"
                          name="option3"
                        />
                        <div className="label">{this.props.t("14 days")}</div>
                      </div>:null}
                      <div className="RadioButtonContainer " onClick={lastDayCustom==="Custom"?null: () => this.lastDayRadioButton("lastDayCustom","Custom")}>
                        <RadioButton
                          id="custom"
                          handler={ lastDayCustom==="Custom"?null:this.lastDayRadioButton}
                          value={"Custom"}
                          checked={lastDayCustom=== "Custom"}
                          style={{color:"#092F41"}}
                          type="radio"
                          name="option4"
                        />
                        <div className="label">{this.props.t("Custom")}</div>
                      </div>
                    </RadioButtonWrapper>
                  </div>

                  {lastDayCustom==="Custom"?
                    <>
                      <Border style={{ background: '#EFEFEF', margin: '8px 0 8px 0px' }} />
                      <SurvivorAverage width="100%" isHeight={"50px"} isMargin="0px" marginb="0px">
                        <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" marginb="12px">
                          {t("Custom last day to join")}
                        </StyledLabel>
                        <CustomInput
                          isFont={"Lato"}
                          isRadius={"4px"}
                          isBorder={"1px solid #BDBDBD"}
                          isBgColor={"white"}
                          type='number'
                          name='lastDayToJoin'
                          onChange={this.onChangeInput}
                          value={lastDayToJoin}
                          maxLength="3"
                          placeholder={"Enter number of days"}
                        />
                      </SurvivorAverage>
                    </>:null}
                </>:null}
                {showDatePopupModal&&<DatePopupCalendar showModal={showDatePopupModal} onClose={this.hideCalendarPopup} date={datePopup==="date"? date: endDate} stateDateSelected={ datePopup==="date"?dayjs(new Date()):date} changeDate={this.onChangeDateValue} type={datePopup} />}
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  };

  stepFiveForm = () => {
    const {
      step,
      emailOption,
    } = this.state;
    const {t} = this.props;
    let emailOptionKeys = Object.keys(emailOption);
    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container height="100%" stepBackground="#005C87" color="#005C87" paddingForm>
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="challenge" padding="20px 20px 265px 20px"/>
            </div>
            <div className="form">
              <div className="formBody">
                {<StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" marginb="0">
                  {t("Email notifications: Select email option for this challenge")}
                </StyledLabel>}
                <div className="radioButtonDiv">
                  <Locationwrapper background="white" isFlex={'1 1 50%'} style={{flexWrap:"nowrap"}} isWidth="25%" marginTop="12px">
                    {emailOptionKeys.map((item, index) => (
                      <div className="checkBoxWidth" key={index}>
                        <span style={{color:"#092F41",gap:"16px"}}>
                          <ManagerIconContainer selected={emailOption[item] === 1} isWidth="20px" isHeight="20px">
                            <div
                              className="archive-action"
                              onClick={() => this.onChangeEmail(item)}
                            >
                              {emailOption[item] === 1 ? RecognitionTickIcon(): null}
                            </div>
                          </ManagerIconContainer>
                          {t("Challenge")}
                          {item == "launch_challenge_email"? t(" Creation"): item == "challenge_reminder_email"? t(" Reminder"): t(" Completion")}
                        </span>
                      </div>))}           
                  </Locationwrapper>
                </div>
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  };

  DropdownIndicator = () => (
    <svg
      width="12"
      height="20"
      viewBox="0 0 12 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 10C12 10.3585 11.8559 10.7169 11.5684 10.9901L2.51663 19.5897C1.94083 20.1368 1.00725 20.1368 0.431681 19.5897C-0.143894 19.0429 -0.143894 18.1561 0.431681 17.609L8.44122 10L0.43196 2.39098C-0.143614 1.84394 -0.143614 0.957264 0.43196 0.410484C1.00753 -0.136826 1.94111 -0.136826 2.51691 0.410484L11.5687 9.00992C11.8563 9.28333 12 9.64172 12 10Z"
        fill="#0D4270"
      />
    </svg>
  );

  toggleMenu = () => {
    this.setState((prevState) => ({
      menuIsOpen: !prevState.menuIsOpen,
    }));
  };

  updateStep = (value) => {
    this.setState({ step: value, buttonClickScrollTop: true, buttonStatus:false });
  };

  showLoaderApiCall = (value) => {
    this.setState({ showLoader:value });
  };

  render() {
    const { step, buttonStatus, title, imgSrc, description, activityType, city_location, teams, endDate, companies, showLoader, challengeLength, isSpouse, isDependent, isEmployee, selectedDailyGoalOption,dailyGoal,usersToInvite,city_department, date, survivorChallenge, lastDayToJoin } = this.state;
    const {locationDetails, role, companyDetails, isAccountManager} = this.props;
    let survivorEndDate = dayjs(dayjs(date).add((challengeLength * 7) - 1, 'days')).format('MM/DD/YYYY');
    let lastDaySelectValue= survivorChallenge?this.calculateDateDifference(date,survivorEndDate): (date&&endDate) && this.calculateDateDifference(date,endDate)

    if (showLoader) {
      return <Waiting />
    }
    console.log("1st blpck",((role != "ADMIN"&&!isAccountManager) && !isEmployee && !isDependent&& !isSpouse && _.isEmpty(locationDetails) && companyDetails && companyDetails['spouse_or_dependent']) || companies.length === 0 || (usersToInvite === 2 && !city_location.length > 0) || (usersToInvite === 1 && !city_department.length > 0) || (usersToInvite === 3 && !teams.length > 0))
    return (
      <React.Fragment>
        {step === 1?this.stepOneForm(): step === 2? this.stepTwoForm(): step === 3 ? this.stepThreeForm(): step === 4 ? this.stepFourForm() : step === 5 && this.stepFiveForm()}
        {step === 1 ? (
          <ButtonContainer>
            <Main>
              <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto" disabled={!title||!imgSrc|| !description} onClick={!title||!imgSrc|| !description?null: () => this.updateStep(2)}>
                Next
                {!title||!imgSrc|| !description ? AdminRightArrowIcon("#989898") : AdminRightArrowIcon()}
              </CommonButtonPopup>
            </Main>
          </ButtonContainer>
        ) : step === 2 ? (
          <ButtonContainer>
            <div className="wrapper">
              <CommonButtonBorder width="200px" height="48px"
                onClick={() => this.updateStep(1)}
                margin="auto auto auto 0px">
                {AdminLeftArrowIcon("#F37A65")}
                Back
              </CommonButtonBorder>
              <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto" disabled={!activityType || (selectedDailyGoalOption == 0 && !dailyGoal )} onClick={!activityType || (selectedDailyGoalOption == 0 && !dailyGoal )?null: () => this.updateStep(3)}>
                Next
                {!activityType || (selectedDailyGoalOption == 0 && !dailyGoal ) ? AdminRightArrowIcon("#989898") : AdminRightArrowIcon()}
              </CommonButtonPopup>
            </div>
          </ButtonContainer>
        ) : (
          step === 3 ? (
            <ButtonContainer>
              <div className="wrapper">
                <CommonButtonBorder width="200px" height="48px"
                  onClick={() => this.updateStep(2)}
                  margin="auto auto auto 0px">
                  {AdminLeftArrowIcon("#F37A65")}
                  Back
                </CommonButtonBorder>
                <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto"
                  disabled={
                    ( !companies.length > 0 && (role === "ADMIN"||isAccountManager)) || ((role != "ADMIN"&&!isAccountManager && usersToInvite !== 0 ) &&(!city_location.length > 0 &&!_.isEmpty(locationDetails) && usersToInvite === 2) || ((role != "ADMIN"&&!isAccountManager && usersToInvite !== 0) && !isEmployee && !isDependent&& !isSpouse && _.isEmpty(locationDetails) && companyDetails && companyDetails['spouse_or_dependent']) || companies.length === 0 || (usersToInvite === 2 && !city_location.length > 0) || (usersToInvite === 1 && !city_department.length > 0) || (usersToInvite === 3 && !teams.length > 0))
                  }
                  onClick={( !companies.length > 0 && (role === "ADMIN"||isAccountManager)) || ((role != "ADMIN"&&!isAccountManager && usersToInvite !== 0) &&(!city_location.length > 0 &&!_.isEmpty(locationDetails) && usersToInvite === 2) || ((role != "ADMIN"&&!isAccountManager && usersToInvite !== 0) && !isEmployee && !isDependent&& !isSpouse && _.isEmpty(locationDetails) && companyDetails && companyDetails['spouse_or_dependent']) || companies.length === 0 || (usersToInvite === 2 && !city_location.length > 0) || (usersToInvite === 1 && !city_department.length > 0) || (usersToInvite === 3 && !teams.length > 0))?null: () => this.updateStep(4)}
                >
                  Next
                  {( !companies.length > 0 && (role === "ADMIN"||isAccountManager)) || ((role != "ADMIN"&&!isAccountManager && usersToInvite !== 0) &&(!city_location.length > 0 &&!_.isEmpty(locationDetails) && usersToInvite === 2) || ((role != "ADMIN"&&!isAccountManager && usersToInvite !== 0) && !isEmployee && !isDependent&& !isSpouse && _.isEmpty(locationDetails) && companyDetails && companyDetails['spouse_or_dependent']) || companies.length === 0 || (usersToInvite === 2 && !city_location.length > 0) || (usersToInvite === 1 && !city_department.length > 0) || (usersToInvite === 3 && !teams.length > 0)) ? AdminRightArrowIcon("#989898") : AdminRightArrowIcon()}
                </CommonButtonPopup>
              </div>
            </ButtonContainer>
          ):step === 4 ?
            <ButtonContainer>
              <div className="wrapper">
                <CommonButtonBorder width="200px" height="48px"
                  onClick={() => this.updateStep(3)}
                  margin="auto auto auto 0px">
                  {AdminLeftArrowIcon("#F37A65")}
                  Back
                </CommonButtonBorder>
                <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto" disabled={!endDate&& challengeLength==null || (lastDaySelectValue>3&& !lastDayToJoin)||buttonStatus} onClick={!endDate&& challengeLength==null|| (lastDaySelectValue>3&& !lastDayToJoin)||buttonStatus?null: () => this.updateStep(5)}>
                  Next
                  {!endDate&& challengeLength==null || (lastDaySelectValue>3&& !lastDayToJoin)||buttonStatus? AdminRightArrowIcon("#989898") : AdminRightArrowIcon()}
                </CommonButtonPopup>
              </div>
            </ButtonContainer>:
            step === 5&&
            <ButtonContainer>
              <div className="wrapper">
                <CommonButtonBorder width="200px" height="48px"
                  onClick={() => this.updateStep(4)}
                  margin="auto auto auto 0px">
                  {AdminLeftArrowIcon("#F37A65")}
                  Back
                </CommonButtonBorder>
                <CommonButtonPopup margin="auto 0 auto auto" width="180px" height="48px" disabled={buttonStatus} onClick={()=>!buttonStatus? this.onSubmit():null}>
                  Launch Challenge{buttonStatus? LaunchIcon("#989898"):LaunchIcon()}
                </CommonButtonPopup>
              </div>
            </ButtonContainer>
        )}
      </React.Fragment>
    );
  }
}

LaunchActivityChallenge.propTypes = {
  isSurvivorChallenge: PropTypes.bool.isRequired,
  createChallenge: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  onHide: PropTypes.func,
  MandatoryFields: PropTypes.array.isRequired,
  survivorChallengeData: PropTypes.object,
  saveChallengeData: PropTypes.func.isRequired,
  allCompanies: PropTypes.array,
  fetchAllCompanies: PropTypes.func.isRequired,
  role: PropTypes.string,
  fetchCompanyForUser: PropTypes.func.isRequired,
  userCompany: PropTypes.object,
  locationDetails: PropTypes.array,
  companyDetails: PropTypes.object,
  allowChallengeEventForSpouseDependent: PropTypes.func,
  isGroupChallenge: PropTypes.bool,
  activityChallengeById: PropTypes.bool,
  createActivityChallenge: PropTypes.func,
  createLibrary: PropTypes.bool,
  editChallengeLibrary: PropTypes.func,
  editLibrary: PropTypes.bool,
  userPermissions: PropTypes.array,
  surveyLibraries: PropTypes.array,
  getSurveyLibraries: PropTypes.func,
  t: PropTypes.func,
  fetchCompanyTeamUsers:PropTypes.func,
  challengeDetails: PropTypes.array,
  getChallengeDetails: PropTypes.func,
  getCompanyLocation: PropTypes.func,
  user: PropTypes.object,
  departmentDetails: PropTypes.array,
  getCompanyDepartment: PropTypes.func,
  waitForCompanyDepartment: PropTypes.bool,
  isAccountManager: PropTypes.bool
};

const mapStateToProps = (state) => ({
  allCompanies: state.challenges.allCompanies,
  userCompany: state.profileData.userCompany,
  locationDetails: state.register.locationDetails,
  companyDetails: state.profileData.companyDetails,
  userPermissions: state.profileData.userPermissions,
  surveyLibraries: state.surveys.surveyLibraries,
  challengeDetails: state.challenges.challengeDetails,
  user: state.profileData.user,
  departmentDetails: state.register.departmentDetails,
  waitForCompanyDepartment: state.register.waitForCompanyDepartment
});

const mapDispatchToProps = (dispatch) => ({
  fetchAllCompanies: () => dispatch(getAllCompanies()),
  saveChallengeData: (data) => dispatch(saveChallengeData(data)),
  fetchCompanyForUser: () => dispatch(getUserCompanyDetails()),
  allowChallengeEventForSpouseDependent: () => dispatch(allowChallengeEventForSpouseDependent),
  editChallengeLibrary: (challenge) => dispatch(editChallengeLibrary(challenge)),
  fetchCompanyTeamUsers: (companyId) => dispatch(fetchCompanyTeamUsers(companyId)),
  createActivityChallenge: (challenge) => dispatch(createActivityChallengeV2(challenge)),
  getChallengeDetails: (id) => dispatch(getActivityChallengeById(id)),
  getCompanyLocation: (id) => dispatch(getCompanyLocation(id)),
  getCompanyDepartment: (id) => dispatch(getCompanyDepartment(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(LaunchActivityChallenge));
